<div *ngIf="loading" class="my-container">
  <ng-template #customLoadingTemplate>
    <div class="custom-class">{{ loaderText }}</div>
  </ng-template>

  <ngx-loading
    [show]="loading"
    [template]="customLoadingTemplate"
  ></ngx-loading>
</div>
<div class="landscape flex-column" [ngClass] = "{'active': isPortrait}" style="display: none;">
  <img src="/assets/img/crewbid-logo.png" class="mt-3 position-absolute landscape-logo" alt="">
  <div class="wrapper">
    <div class="image">
      <img src="/assets/img/rotate-screen.svg" alt="" />
    </div>
    <div class="text">
      <p>For the better user experiance please change the screen to landscape view</p>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
